import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import { TaskBlockerBlockerType } from '@urbanx/agx.activities.client'
import { JSX, ReactNode } from 'react'
import { NoLaunchDateBlocker } from './NoLaunchDateBlocker'

interface PreLaunchTaskBlockerProps {
  task: AutopilotTaskDto
  children: ReactNode
}

export const PreLaunchTaskBlocker = ({
  task,
  children,
}: PreLaunchTaskBlockerProps): JSX.Element => {
  const blockerTypes = new Set((task.blockers ?? []).map((b) => b.blockerType))

  if (blockerTypes.has(TaskBlockerBlockerType.LaunchDateNotSet)) {
    return <NoLaunchDateBlocker task={task} />
  }

  return <>{children}</>
}
